import { useEffect, useRef, useState } from 'react';
import { Box, HStack, Pressable, Text, useMediaQuery } from 'native-base';
import { useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../../utils/fonts';
import { COLORS } from '../../../../utils/colors';
import AttachmentsCards from '../../../attachmentCards';
import { MobileBasicDetails, WebBasicDetails } from '../details_responsive';
import { MOBILE_VIEW_WIDTH } from '../../../../utils/screens';
import CommonAvatar from '../../../../components/avatar';
import { addIconSVG, editIconDetailsPage } from '../../../../utils/svg';
import { Toaster } from '../../../../components/toaster';
import CustomButton from '../../../../components/button';
import CustomModal from '../../../../components/modal';
import FileUploader from '../../../fileUpload';
import {
  getSchemaAPI,
  getSchemaDetailsAPI,
  getWorkflowAPI,
  putWorkflowAPI,
  uploadFileAPI,
} from '../../../../api/apis/workflow';
import {
  createEventAPI,
  uploadExtraEventDocs,
} from '../../../../api/apis/event';
import { hasPermission, statusMap } from '../../../../utils/permission';
import MobileModelSheet from '../../../../components/actionSheet';
import DividerLine from '../../../../components/divider';
import { LoaderAnimation } from '../../../../components/spinner';
import MiceBasicDetails from '../../../../pages/landingPage/miceRequestFlow/basicDetail';
import { eventErrorPayload, miceErrorPayload } from '../../../../utils/payload';
import { getBlockedTravelPartners } from '../../../../api/apis/quicklinks';
import { schemaExtractor } from '../../../../utils/schemaExtractor';
import MiceDetails from '../../../../pages/landingPage/miceRequestFlow/miceDetail';
import EventBasicDetails from '../../../../pages/landingPage/eventRequestFlow/basicDetail';
import EventDetails from '../../../../pages/landingPage/eventRequestFlow/eventDetail';
import {
  emailValidator,
  eventFormValidator,
  miceFormValidator,
} from '../../../../utils/validator';
import config from '../../../../utils/config';

const BasicDetailContents = ({ getEventDetails }) => {
  const childref = useRef(null);
  const childRef = useRef(null);
  const [eventFormData, setEventFormData] = useState({});
  const [miceFormData, setMiceFormData] = useState({});
  const [eventErrorFormData, setErrorEventFormData] =
    useState(eventErrorPayload);
  const [miceErrorFormData, setErrorMiceFormData] = useState(miceErrorPayload);
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const eventsDetail = useSelector((state) => {
    return state.event.selectedEvent;
  });
  const options = [
    { id: '1', value: 'conference_hall', label: 'Conference Hall' },
    { id: '2', value: 'gala_dinner', label: 'Gala Dinner' },
    { id: '3', value: 'event_management', label: 'Event Management' },
  ];
  const [basicData, setBasicData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [selected, setSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [blockedTravelPartners, setBlockedTravelPartners] = useState([]);
  const [files, setFiles] = useState([]);
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [selectedValue, setSelectedValue] = useState('');
  const eventTab = activeTab === 'event' ? 'Event' : 'MICE';
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [approved, setApproved] = useState(false);
  const [forceRemount, setForceRemount] = useState(false);
  const [eventAgency, setEventAgency] = useState([]);
  const [miceAgency, setMiceAgency] = useState([]);
  const [workflow, setWorkflow] = useState({});
  const [expense, setExpense] = useState({});

  useEffect(() => {
    if (Object.keys(eventsDetail).length > 0) {
      parseEventData(eventsDetail);
    }
    AddWorkflow();
    if (!hasPermission('VENDOR') && hasPermission('SHOW_POLICY')) getAgencies();
    getSchema();
    eventsDetail &&
      eventsDetail.agency &&
      eventsDetail.agency.map((item) => {
        if (item.status === 'active') {
          setExpense(item.expense_path);
          setApproved(true);
        }
        const emailIdMatches =
          item?.emailId === userInfo?.email ||
          (Array.isArray(item?.emailId) &&
            item.emailId.includes(userInfo?.email));
        if (emailIdMatches && item.status === 'active') {
          setSelected(true);
        }
      });
  }, [eventsDetail]);

  const showToaster = (message) => {
    toaster(
      message || "You've selected this agency 3 times, please choose another agency",
      'error',
      'error'
    );
  };

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        let allStatus = ['NEW', 'pending'];
        item &&
          item.steps &&
          item.steps.map((status) => {
            allStatus.push(status.name);
          });
        if (item.name === 'EventWorkflow') {
          workflows['event'] = item;
        }
      });
      setWorkflow(workflows);
    }
  };

  const getSchema = async () => {
    let documentSchema = '';
    let res = await getSchemaAPI();
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return;
    } else {
      res &&
        res.data.data.data &&
        res.data.data.data.map((item) => {
          if (item.title === 'CREATE_EVENT') {
            documentSchema = item._id;
          }
        });
    }

    if (documentSchema) {
      let res = await getSchemaDetailsAPI(documentSchema);
      if (res.error) {
        toaster(res.message, 'error', 'error');
        return;
      } else {
        let extracted = schemaExtractor(res.data.data.data.properties);
        setEventFormData(extracted);
        setMiceFormData(extracted);
      }
    }
  };

  const getAgencies = async () => {
    // let res = await getTravelPartnersAPI(activeTab);
    let res = await getBlockedTravelPartners(activeTab);
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return;
    } else {
      let agency = [];
      res.data.data.data.forEach((item) => {
        agency.push({
          id: item._id,
          value: item._id,
          label: item.agency,
          emailId: item?.contactDetails?.map((contact) => contact?.emailId[0]),
          blocked: item.blocked,
        });
        if (item.blocked)
          setBlockedTravelPartners((prevVal) => [...prevVal, item._id]);
      });
      if (activeTab === 'event') {
        setEventAgency(agency);
      }
      if (activeTab === 'mice') {
        setMiceAgency(agency);
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const openModal = (value) => {
    setSelectedValue(value);
    let updatedDetailCopy = JSON.parse(JSON.stringify(eventsDetail));

    // Handle agency data transformation for editing
    if (updatedDetailCopy?.self_agency_approval) {
      // If self_agency_approval is true, set agency to contain "Self" option
      updatedDetailCopy.agency = [{
        id: "self",
        value: "self",
        label: "Self",
        isSelfOption: true
      }];
    } else {
      // Transform existing agency data
      updatedDetailCopy.agency = updatedDetailCopy.agency.map((item, ind) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
    }

    if (activeTab === 'mice')
      updatedDetailCopy.additional_info = {
        ...updatedDetailCopy.additional_info,
        service_required:
          updatedDetailCopy.additional_info.service_required.map((item) => {
            let ind = options.find((val) => item === val.value);
            return ind;
          }),
      };

    setMiceFormData(updatedDetailCopy);
    setEventFormData(updatedDetailCopy);
    setForceRemount(!forceRemount);
    !MobileWindow && scrollToTop();
    setShowModal(true);
  };

  const closeModal = () => {
    setFiles([]);
    setMiceFormData({});
    setEventFormData({});
    setSelectedValue('');
    setErrorMiceFormData(miceErrorPayload);
    setErrorEventFormData(eventErrorPayload);
    setForceRemount(!forceRemount);
    setShowModal(false);
  };

  const formatBudget = (number) => {
    const formattedNumber = new Intl.NumberFormat('en-IN', {
      style: 'decimal',
      maximumFractionDigits: 0,
    }).format(number);

    return formattedNumber;
  };

  const formatDate = (date) => {
    const dateString = date;
    const [year, month, day] = dateString.split('-');
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  const eventLocation = {
    within_india: 'Within India',
    outside_india: 'Outside India',
  };

  const hotelRequirement = {
    with_hotel: 'With Hotel',
    without_hotel: 'Without Hotel',
  };

  const parseEventData = (eventsDetail) => {
    let agencyName = '-';
    eventsDetail &&
      eventsDetail.agency &&
      eventsDetail.agency.length > 0 &&
      eventsDetail.agency.map((item) => {
        if (item.status === 'active') {
          agencyName = item.name;
        }
      });

    let alldata = [];
    if (eventsDetail.type === 'mice') {
      alldata.push(
        {
          heading: 'Conference Location',
          name: eventLocation[
            eventsDetail?.additional_info?.conference_location
          ],
        },
        {
          heading: 'Hotel Requirement',
          name: hotelRequirement[
            eventsDetail?.additional_info?.hotel_requirement
          ],
        }
      );
    }

    if (eventsDetail.type === 'event') {
      alldata.push(
        { heading: 'Quiz Id', name: eventsDetail?.quiz_title || '-' },
        {
          heading: 'Premium Booking',
          name: eventsDetail?.is_premium === true ? 'Yes' : eventsDetail?.is_premium === false ? 'No' : '-'
        }
      );
    }

    alldata.push(
      { heading: 'Agency Name', name: eventsDetail?.self_agency_approval === true ? 'Self' : agencyName },
      { heading: 'Business Name', name: eventsDetail?.business },
      {
        heading: 'Coordinator Name 1',
        name: eventsDetail?.contact_details?.coordinator_name,
      },
      {
        heading: 'Contact Number 1',
        name: eventsDetail?.contact_details?.phone
          ? eventsDetail?.contact_details?.phone
          : '-',
      },
      { heading: 'Email ID 1', name: eventsDetail?.contact_details?.email },



      {
        heading: 'Coordinator Name 2',
        name: eventsDetail?.contact_details?.coordinator_name_2 || "-",
      },
      {
        heading: 'Contact Number 2',
        name: eventsDetail?.contact_details?.phone_2
          ? eventsDetail?.contact_details?.phone_2
          : '-',
      },
      { heading: 'Email ID 2', name: eventsDetail?.contact_details?.email_2 || "-" },


      {
        heading: 'Coordinator Name 3',
        name: eventsDetail?.contact_details?.coordinator_name_3 || "-",
      },
      {
        heading: 'Contact Number 3',
        name: eventsDetail?.contact_details?.phone_3
          ? eventsDetail?.contact_details?.phone_3
          : '-',
      },
      { heading: 'Email ID 3', name: eventsDetail?.contact_details?.email_3 || "-" }
    );

    if (eventsDetail.type === 'mice') {
      alldata.push(
        {
          heading: 'Boarding From',
          name: eventsDetail?.additional_info?.boarding_from
            ? eventsDetail?.additional_info?.boarding_from
            : '-',
        },
        {
          heading: 'Destination To',
          name: eventsDetail?.additional_info?.destination_to
            ? eventsDetail?.additional_info?.destination_to
            : '-',
        },
        {
          heading: '',
          name: '',
        },
        {
          heading: 'Other Requirements',
          name: eventsDetail?.other_requirements
            ? eventsDetail?.other_requirements
            : '-',
        }
      );
    }
    setEventData(alldata);

    let allDatas = [
      { heading: `${eventTab} Name`, name: eventsDetail?.event_name },
      {
        heading: `${eventTab} Location`,
        name: eventsDetail?.event_location ? eventsDetail?.event_location : '-',
      },

      {
        heading: `${eventTab} From Date`,
        name: formatDate(eventsDetail?.from_date),
      },
      {
        heading: `${eventTab} To Date`,
        name: formatDate(eventsDetail?.to_date),
      },
    ];

    if (eventsDetail.type === 'mice')
      allDatas.unshift({
        heading: 'Service Type',
        name: eventsDetail?.additional_info?.service_required
          ? eventsDetail?.additional_info?.service_required
            .map((item) => {
              return item
                .split('_')
                .map((word) => {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');
            })
            .join(', ')
          : '-',
      });

    if (eventsDetail.type === 'mice') {
      allDatas.push(
        {
          heading: 'Number of Person',
          name: eventsDetail?.additional_info?.number_of_persons
            ? eventsDetail?.additional_info?.number_of_persons
            : '-',
        }
      );

      // Only show budget if user is not an employee
      if (userInfo?.role !== 'employee') {
        allDatas.push({
          heading: 'Estimated Budget (in rupees)',
          name: eventsDetail?.estimated_budget
            ? formatBudget(eventsDetail?.estimated_budget)
            : '-',
        });
      }

      allDatas.push(
        eventsDetail?.additional_info?.hotel_requirement === 'with_hotel'
          ? {
            heading: 'Number of Nights',
            name: eventsDetail?.additional_info?.number_of_nights
              ? eventsDetail?.additional_info?.number_of_nights
              : '-',
          }
          : {
            heading: '',
            name: '',
          },
        {
          heading: '',
          name: '',
        },
        {
          heading: '',
          name: '',
        },
        // {
        //   heading: "",
        //   name: "",
        // },
        {
          heading: 'About MICE',
          name: eventsDetail?.about_event ? eventsDetail?.about_event : '-',
        }
      );
    } else {
      // Only show budget if user is not an employee
      if (userInfo.role !== 'employee') {
        allDatas.push({
          heading: 'Estimated Budget (in rupees)',
          name: eventsDetail?.estimated_budget
            ? formatBudget(eventsDetail?.estimated_budget)
            : '-',
        });
      }

      allDatas.push(
        {
          heading: 'About Event',
          name: eventsDetail?.about_event ? eventsDetail?.about_event : '-',
        },
        {
          heading: 'Other Requirements',
          name: eventsDetail?.other_requirements
            ? eventsDetail?.other_requirements
            : '-',
        }
      );
    }

    setBasicData(allDatas);
  };

  const getPopupModalTitle = () => {
    if (selectedValue === 'docs') return <Text>Add Document</Text>;
    if (selectedValue === 'edit_basic') return <Text>Edit basic detail</Text>;
    if (selectedValue === 'edit_event')
      return (
        <Text>
          Edit {eventsDetail.type === 'mice' ? 'MICE' : 'Event'} detail
        </Text>
      );
  };

  const setDefaultErrorFrom = () => {
    setErrorEventFormData(eventErrorPayload);
    setErrorMiceFormData(miceErrorPayload);
  };

  const filterBlockedTravelPartners = (formData) => {
    // Don't filter if self_agency_approval is true (Self is selected)
    if (formData?.self_agency_approval) {
      return formData;
    }

    blockedTravelPartners.forEach((id) => {
      formData.agency = formData.agency.filter((item) => item.id !== id);
    });
    return formData;
  };

  const editBasicForm = () => {
    if (eventsDetail.type === 'mice') {
      filterBlockedTravelPartners(miceFormData);
      return (
        <MiceBasicDetails
          miceFormData={miceFormData}
          setMiceFormData={setMiceFormData}
          miceErrorFormData={miceErrorFormData}
          setDefaultErrorFrom={setDefaultErrorFrom}
          miceAgency={miceAgency}
          forceRemount={forceRemount}
          childref={childref}
          ref={childref}
          showModal={showModal}
          edit
          showToaster={showToaster}
        />
      );
    } else {
      filterBlockedTravelPartners(eventFormData);
      return (
        <EventBasicDetails
          eventFormData={eventFormData}
          setEventFormData={setEventFormData}
          eventErrorFormData={eventErrorFormData}
          setDefaultErrorFrom={setDefaultErrorFrom}
          eventAgency={eventAgency}
          forceRemount={forceRemount}
          childref={childref}
          ref={childref}
          showModal={showModal}
          edit
          showToaster={showToaster}
        />
      );
    }
  };

  const editEventForm = () => {
    if (eventsDetail.type === 'mice') {
      return (
        <MiceDetails
          miceFormData={miceFormData}
          setMiceFormData={setMiceFormData}
          miceErrorFormData={miceErrorFormData}
          setDefaultErrorFrom={setDefaultErrorFrom}
          forceRemount={forceRemount}
          childref={childref}
          ref={childref}
          showModal={showModal}
          edit
        />
      );
    } else {
      return (
        <EventDetails
          eventFormData={eventFormData}
          setEventFormData={setEventFormData}
          eventErrorFormData={eventErrorFormData}
          setDefaultErrorFrom={setDefaultErrorFrom}
          forceRemount={forceRemount}
          childref={childref}
          ref={childref}
          showModal={showModal}
          edit
        />
      );
    }
  };

  const getPopupModalChildren = () => {
    if (selectedValue === 'docs')
      return (
        <FileUploader
          multiple
          files={files}
          setFiles={(files) => {
            setFiles(files);
          }}
          accept={['xls', 'xlsx', 'pdf', 'csv']}
          types={'.xls, .xlsx, .pdf, .csv'}
          forceRemount={forceRemount}
        />
      );

    if (selectedValue === 'edit_basic') return editBasicForm();
    if (selectedValue === 'edit_event') return editEventForm();
  };

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join('-') +
        'T' +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds()),
        ].join(':') +
        '.' +
        '616838+00:00'
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const uploadFilesToServer = async (data, type) => {
    let docs = [];
    
    // Check if data exists and is valid before uploading
    if (!data || !Array.isArray(data) || data.length === 0) {
      return docs;
    }
    
    try {
      let res = await uploadFileAPI(data, type === 'logo' ? 'image' : undefined, type === 'logo' ? 'image' : type);
      
      // Check if res exists and is an array before mapping
      if (res && Array.isArray(res)) {
        res.map((item) => {
          if (item && item.error) {
            toaster('Upload file failed', 'error', 'error');
            return;
          }
          if (item && item.data && item.data.data && item.data.data.data) {
            docs.push({
              doc_type: item.data.data.data.doc_type,
              file_size: item.data.data.data.file_size.toString(),
              file_name: item.data.data.data.file_name,
              uploaded_time: getStartDateFormat(new Date()),
            });
          }
        });
      }
    } catch (error) {
      console.error('Upload error:', error);
      toaster('Upload failed', 'error', 'error');
    }

    return docs;
  };

  const getStartDateFormats = (dateString, type = 'start') => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }

    function formatDate(date, type) {
      let hours, minutes, seconds;
      if (type === 'start') {
        hours = minutes = seconds = '00';
      } else if (type === 'end') {
        hours = '23';
        minutes = '59';
        seconds = '00';
      } else {
        hours = padTo2Digits(date.getHours());
        minutes = padTo2Digits(date.getMinutes());
        seconds = padTo2Digits(date.getSeconds());
      }

      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join('-') +
        'T' +
        [hours, minutes, seconds].join(':') +
        '.616838+00:00'
      );
    }

    const formattedDate = formatDate(date, type);

    return formattedDate;
  };

  function isValidDateFormat(dateString) {
    // Regular expression to match "YYYY-MM-DD" format
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(dateString);
  }

  const handleDaysCalculation = (starts_at, ends_at) => {
    const fromDate = new Date(starts_at);
    const toDate = new Date(ends_at);
    const differenceInDays =
      Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
    return differenceInDays;
  };

  const onUpdateRequest = async () => {
    LoaderAnimation.show();
    if (activeTab === 'event') {
      let updatedData = { ...eventFormData };
      if (selectedValue === 'edit_basic') {
        let error = false;
        let errorMessage = { ...eventErrorFormData };
        let basiceventData = childref.current.onSubmitDataInput();
        if (!basiceventData?.self_agency_approval) {
          if (
            basiceventData.agency === '' ||
            basiceventData.agency.length === 0
          ) {
            error = true;
            errorMessage['agency'] = 'Please select Agencies';
          }
          if (
            basiceventData.agency.length > 0 &&
            basiceventData.agency.length < 3
          ) {
            error = true;
            errorMessage['agency'] = 'Please select minimum 3 Agencies';
          }
        }
        // if (basiceventData.is_premium === '' || basiceventData.is_premium === null || basiceventData.is_premium === undefined) {
        //   error = true;
        //   errorMessage['is_premium'] = 'Please select Premium or Not';
        // }
        // if (basiceventData.quiz_id === '') {
        //   error = true;
        //   errorMessage['quiz_id'] = 'Please select Quiz Id';
        // }
        if (basiceventData.business === '') {
          error = true;
          errorMessage['business'] = 'Please enter Business Name';
        } else if (
          basiceventData.business.length < 3 ||
          !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
            basiceventData.business
          )
        ) {
          error = true;
          errorMessage['business'] = 'Please enter proper Business Name';
        } else if (basiceventData.business.length > 500) {
          error = true;
          errorMessage['business'] =
            'Please enter Business Name less than 500 characters';
        }
        if (basiceventData.coordinator_name === '') {
          error = true;
          errorMessage['coordinator_name'] = 'Please enter Coordinator Name 1';
        } else if (
          basiceventData.coordinator_name.length < 3 ||
          !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
            basiceventData.coordinator_name
          )
        ) {
          error = true;
          errorMessage['coordinator_name'] =
            'Please enter proper Coordinator Name 1';
        } else if (basiceventData.coordinator_name.length > 500) {
          error = true;
          errorMessage['coordinator_name'] =
            'Please enter Coordinator Name 1 less than 500 characters';
        }
        if (basiceventData.email === '') {
          error = true;
          errorMessage['email'] = 'Please enter Email ID 1';
        }
        if (!emailValidator(basiceventData.email)) {
          error = true;
          errorMessage['email'] = 'Please enter valid Email ID 1';
        }

        if (basiceventData.phone !== '' && basiceventData.phone.length !== 10) {
          error = true;
          errorMessage['phone'] = 'Please enter 10 digit Contact Number 1';
        }

        if (basiceventData.coordinator_name_2 !== "") {
          if (
            basiceventData.coordinator_name_2.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name_2
            )
          ) {
            error = true;
            errorMessage['coordinator_name_2'] =
              'Please enter proper Coordinator Name 2';
          } else if (basiceventData.coordinator_name_2.length > 500) {
            error = true;
            errorMessage['coordinator_name_2'] =
              'Please enter Coordinator Name 2 less than 500 characters';
          }
        }
        if (basiceventData.email_2 !== '' && !emailValidator(basiceventData.email_2)) {
          error = true;
          errorMessage['email_2'] = 'Please enter valid Email ID 2';
        }
        if (
          basiceventData.phone_2 !== '' &&
          basiceventData.phone_2.length !== 10
        ) {
          error = true;
          errorMessage['phone_2'] = 'Please enter 10 digit Contact Number 2';
        }


        if (basiceventData.coordinator_name_3 !== "") {
          if (
            basiceventData.coordinator_name_3.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name_3
            )
          ) {
            error = true;
            errorMessage['coordinator_name_3'] =
              'Please enter proper Coordinator Name 3';
          } else if (basiceventData.coordinator_name_3.length > 500) {
            error = true;
            errorMessage['coordinator_name_3'] =
              'Please enter Coordinator Name 3 less than 500 characters';
          }
        }
        if (basiceventData.email_3 !== '' && !emailValidator(basiceventData.email_3)) {
          error = true;
          errorMessage['email_3'] = 'Please enter valid Email ID 3';
        }
        if (
          basiceventData.phone_3 !== '' &&
          basiceventData.phone_3.length !== 10
        ) {
          error = true;
          errorMessage['phone_3'] = 'Please enter 10 digit Contact Number 3';
        }


        if (error) {
          setErrorEventFormData(errorMessage);
          toaster('Enter all the details correctly', 'error', 'error');
          LoaderAnimation.hide();
          return;
        }
        let data = { ...eventFormData };
        Object.keys(basiceventData).map((key) => {
          data[key] = basiceventData[key];
        });
        updatedData = data;
        setEventFormData(data);
      }
      if (selectedValue === 'edit_event') {
        let error = false;
        let errorMessage = { ...eventErrorFormData };
        let basiceventData = childref.current.onSubmitDataInput();
        if (eventFormData.from_date === '') {
          error = true;
          errorMessage['from_date'] = 'Please enter Event From Date';
        }
        if (eventFormData.to_date === '') {
          error = true;
          errorMessage['to_date'] = 'Please enter Event To Date';
        }
        if (
          basiceventData.other_requirements !== '' &&
          basiceventData.other_requirements.length > 0 &&
          basiceventData.other_requirements.length > 5000
        ) {
          error = true;
          errorMessage['other_requirements'] =
            'Please enter Other Requirements less than 5000 characters';
        }
        if (
          basiceventData.about_event !== '' &&
          basiceventData.about_event.length > 0 &&
          basiceventData.about_event.length > 5000
        ) {
          error = true;
          errorMessage['about_event'] =
            'Please enter About Event less than 5000 characters';
        }
        if (
          basiceventData.event_location !== '' &&
            /https?:\/\//.test(basiceventData.event_location)
            ? !(
              /^https?:\/\/(www\.)?google\.com\/maps\/(place\/|\?)/.test(
                basiceventData.event_location
              ) ||
              /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(
                basiceventData.event_location
              ) ||
              /^https:\/\/www\.google\.com\/search\?q=[^&]+(&[^#]*)?(#.+)?$/.test(
                basiceventData.event_location
              )
            )
            : !/^[^<>~"`{}\\]*$/.test(basiceventData.event_location)
        ) {
          error = true;
          errorMessage['event_location'] = 'Please enter proper Event Location';
        }
        if (
          basiceventData.event_location !== '' &&
          !/https?:\/\//.test(basiceventData.event_location) &&
          basiceventData.event_location.length > 500
        ) {
          error = true;
          errorMessage['event_location'] =
            'Please enter Event Location less than 500 characters';
        }

        if (error) {
          setErrorEventFormData(errorMessage);
          toaster('Enter all the details correctly', 'error', 'error');
          LoaderAnimation.hide();
          return;
        }
        let data = { ...eventFormData };
        Object.keys(basiceventData).map((key) => {
          data[key] = basiceventData[key];
        });
        updatedData = data;
        setEventFormData(data);
      }

      let payload = updatedData;
      payload['type'] = 'event';
      if (isValidDateFormat(payload['from_date']))
        payload['starts_at'] = getStartDateFormats(
          payload['from_date'],
          'start'
        );
      if (isValidDateFormat(payload['to_date']))
        payload['ends_at'] = getStartDateFormats(payload['to_date'], 'end');

      let calc = handleDaysCalculation(
        payload['from_date'],
        payload['to_date']
      );
      if (
        payload.event_break_down &&
        payload.event_break_down.length !== calc
      ) {
        if (payload.event_break_down.length > calc) {
          payload.event_break_down.splice(
            calc,
            payload.event_break_down.length - calc
          );
        }
        if (payload.event_break_down.length < calc) {
          let length = calc - payload.event_break_down.length;
          for (let i = 0; i <= length; i++) {
            const key = `Day ${payload.event_break_down.length + 1}`;
            payload.event_break_down.push({
              [key]: {
                agenda: [
                  {
                    type: '',
                    title: '',
                    start_time: '',
                    end_time: '',
                    location: '',
                    speaker_name: '',
                    speaker_designation: '',
                    speaker_topic: '',
                    speaker_details: '',
                    file_name: '',
                    description: '',
                  },
                ],
                menu: [{ title: '', list: [] }],
                status: '',
              },
            });
          }
        }
      }

      payload['contact_details'] = {
        coordinator_name: payload.coordinator_name,
        phone: payload.phone,
        email: payload.email,
        coordinator_name_2: payload.coordinator_name_2,
        phone_2: payload.phone_2,
        email_2: payload.email_2,
        coordinator_name_3: payload.coordinator_name_3,
        phone_3: payload.phone_3,
        email_3: payload.email_3
      };
      let agencyStructure = [];
      if (payload.self_agency_approval) {
        payload.agency = [];
      } else {
        payload.agency &&
          payload.agency.map((item) => {
            agencyStructure.push({
              id: item.value,
              name: item.label,
              status: 'null',
              emailId: item.emailId,
              quotation_path: item?.quotation_path
            });
          });
        payload.agency = agencyStructure;
      }
      
      // Handle logo upload for basic details update
      if (payload.logo && Array.isArray(payload.logo) && payload.logo.length > 0) {
        // Check if logo contains File objects (new uploads) or server data (existing)
        const hasFileObjects = payload.logo.some(item => item instanceof File);
        
        if (hasFileObjects) {
          // Only upload if there are actual File objects
          let docs = await uploadFilesToServer(payload.logo, 'logo');
          payload.logo = docs;
        } else {
          // Keep existing server data as is
          payload.logo = payload.logo;
        }
      } else {
        payload.logo = [];
      }
      
      payload.workflow_instance_id = payload['_id'];
      let instance_id = payload['_id'];
      delete payload['additional_info'];
      delete payload['current_step'];
      delete payload['metadata'];
      delete payload['status'];
      delete payload['_id'];
      delete payload['quiz_title']

      let res = await putWorkflowAPI(
        payload,
        workflow['event']['_id'],
        eventsDetail.current_step,
        instance_id,
        'EDIT_EVENT'
      );
      if (res.error) {
        toaster(res.message, 'error', 'error');
        LoaderAnimation.hide();
        return;
      } else {
        toaster('Event Updated Successfully', 'success', 'success');
        await getEventDetails();
        closeModal();
      }
    }

    if (activeTab === 'mice') {
      let updatedData = { ...miceFormData };
      if (selectedValue === 'edit_basic') {
        let error = false;
        let errorMessage = { ...miceErrorFormData };
        let basiceventData = childref.current.onSubmitDataInput();
        if (!basiceventData?.self_agency_approval) {
          if (
            basiceventData.agency === '' ||
            basiceventData.agency.length === 0
          ) {
            error = true;
            errorMessage['agency'] = 'Please select Agencies';
          }
          if (
            basiceventData.agency.length > 0 &&
            basiceventData.agency.length < 3
          ) {
            error = true;
            errorMessage['agency'] = 'Please select minimum 3 Agencies';
          }
        }
        if (basiceventData.additional_info.conference_location === '') {
          error = true;
          errorMessage['conference_location'] =
            'Please Select Conference Location';
        }
        if (basiceventData.additional_info.hotel_requirement === '') {
          error = true;
          errorMessage['hotel_requirement'] = 'Please select Hotel Requirement';
        }
        // if (basiceventData.is_premium === '' || basiceventData.is_premium === null || basiceventData.is_premium === undefined) {
        //   error = true;
        //   errorMessage['is_premium'] = 'Please select Premium or Not';
        // }
        // if (basiceventData.quiz_id === '') {
        //   error = true;
        //   errorMessage['quiz_id'] = 'Please select Quiz Id';
        // }
        if (basiceventData.business === '') {
          error = true;
          errorMessage['business'] = 'Please enter Business Name';
        } else if (
          basiceventData.business.length < 3 ||
          !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
            basiceventData.business
          )
        ) {
          error = true;
          errorMessage['business'] = 'Please enter proper Business Name';
        } else if (basiceventData.business.length > 500) {
          error = true;
          errorMessage['business'] =
            'Please enter Business Name less than 500 characters';
        }
        if (basiceventData.coordinator_name === '') {
          error = true;
          errorMessage['coordinator_name'] = 'Please enter Coordinator Name 1';
        } else if (
          basiceventData.coordinator_name.length < 3 ||
          !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
            basiceventData.coordinator_name
          )
        ) {
          error = true;
          errorMessage['coordinator_name'] =
            'Please enter proper Coordinator Name 1';
        } else if (basiceventData.coordinator_name.length > 500) {
          error = true;
          errorMessage['coordinator_name'] =
            'Please enter Coordinator Name 1 less than 500 characters';
        }
        if (basiceventData.email === '') {
          error = true;
          errorMessage['email'] = 'Please enter Email ID 1';
        }
        if (!emailValidator(basiceventData.email)) {
          error = true;
          errorMessage['email'] = 'Please enter valid Email ID 1';
        }
        if (basiceventData.coordinator_name_2 !== "") {
          if (
            basiceventData.coordinator_name_2.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name_2
            )
          ) {
            error = true;
            errorMessage['coordinator_name_2'] =
              'Please enter proper Coordinator Name 2';
          } else if (basiceventData.coordinator_name_2.length > 500) {
            error = true;
            errorMessage['coordinator_name_2'] =
              'Please enter Coordinator Name 2 less than 500 characters';
          }
        }
        if (basiceventData.email_2 !== '' && !emailValidator(basiceventData.email_2)) {
          error = true;
          errorMessage['email_2'] = 'Please enter valid Email ID 2';
        }
        if (
          basiceventData.phone_2 !== '' &&
          basiceventData.phone_2.length !== 10
        ) {
          error = true;
          errorMessage['phone_2'] = 'Please enter 10 digit Contact Number 2';
        }


        if (basiceventData.coordinator_name_3 !== "") {
          if (
            basiceventData.coordinator_name_3.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name_3
            )
          ) {
            error = true;
            errorMessage['coordinator_name_3'] =
              'Please enter proper Coordinator Name 3';
          } else if (basiceventData.coordinator_name_3.length > 500) {
            error = true;
            errorMessage['coordinator_name_3'] =
              'Please enter Coordinator Name 3 less than 500 characters';
          }
        }
        if (basiceventData.email_3 !== '' && !emailValidator(basiceventData.email_3)) {
          error = true;
          errorMessage['email_3'] = 'Please enter valid Email ID 3';
        }
        if (
          basiceventData.phone_3 !== '' &&
          basiceventData.phone_3.length !== 10
        ) {
          error = true;
          errorMessage['phone_3'] = 'Please enter 10 digit Contact Number 3';
        }

        if (
          basiceventData.additional_info.boarding_from !== '' &&
          basiceventData.additional_info.boarding_from.length < 3
        ) {
          error = true;
          errorMessage['boarding_from'] = 'Please enter proper Boarding From';
        } else if (
          basiceventData.additional_info.boarding_from !== '' &&
          basiceventData.additional_info.boarding_from.length > 3 &&
          basiceventData.additional_info.boarding_from.length > 500
        ) {
          error = true;
          errorMessage['boarding_from'] =
            'Please enter Boarding From less than 500 characters';
        }
        if (
          basiceventData.additional_info.destination_to !== '' &&
          basiceventData.additional_info.destination_to.length < 3
        ) {
          error = true;
          errorMessage['destination_to'] = 'Please enter proper Destination To';
        } else if (
          basiceventData.additional_info.destination_to !== '' &&
          basiceventData.additional_info.destination_to.length > 3 &&
          basiceventData.additional_info.destination_to.length > 500
        ) {
          error = true;
          errorMessage['destination_to'] =
            'Please enter Destination To less than 500 characters';
        }
        if (basiceventData.phone !== '' && basiceventData.phone.length !== 10) {
          error = true;
          errorMessage['phone'] = 'Please enter 10 digit Contact Number 1';
        }
        if (
          basiceventData.other_requirements !== '' &&
          basiceventData.other_requirements.length > 0 &&
          basiceventData.other_requirements.length > 5000
        ) {
          error = true;
          errorMessage['other_requirements'] =
            'Please enter Other Requirements less than 5000 characters';
        }

        if (error) {
          setErrorMiceFormData(errorMessage);
          toaster('Enter all the details correctly', 'error', 'error');
          LoaderAnimation.hide();
          return;
        }
        let data = { ...miceFormData };
        Object.keys(basiceventData).map((key) => {
          data[key] = basiceventData[key];
        });
        updatedData = data;
        setMiceFormData(data);
      }
      if (selectedValue === 'edit_event') {
        let error = false;
        let errorMessage = { ...miceErrorFormData };
        let basiceventData = childref.current.onSubmitDataInput();
        if (
          basiceventData.additional_info.service_required === '' ||
          basiceventData.additional_info.service_required.length === 0
        ) {
          error = true;
          errorMessage['service_required'] = 'Please select Service Type';
        }
        if (basiceventData.from_date === '') {
          error = true;
          errorMessage['from_date'] = 'Please enter Event From Date';
        }
        if (basiceventData.to_date === '') {
          error = true;
          errorMessage['to_date'] = 'Please enter Event To Date';
        }
        if (
          basiceventData.additional_info.hotel_requirement === 'with_hotel' &&
          basiceventData.additional_info.number_of_nights === ''
        ) {
          error = true;
          errorMessage['number_of_nights'] = 'Please enter Number of Nights';
        }
        if (
          basiceventData.about_event !== '' &&
          basiceventData.about_event.length > 0 &&
          basiceventData.about_event.length > 5000
        ) {
          error = true;
          errorMessage['about_event'] =
            'Please enter About MICE less than 5000 characters';
        }
        if (
          basiceventData.event_location !== '' &&
            /https?:\/\//.test(basiceventData.event_location)
            ? !(
              /^https?:\/\/(www\.)?google\.com\/maps\/(place\/|\?)/.test(
                basiceventData.event_location
              ) ||
              /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(
                basiceventData.event_location
              ) ||
              /^https:\/\/www\.google\.com\/search\?q=[^&]+(&[^#]*)?(#.+)?$/.test(
                basiceventData.event_location
              )
            )
            : !/^[^<>~"`{}\\]*$/.test(basiceventData.event_location)
        ) {
          error = true;
          errorMessage['event_location'] = 'Please enter proper MICE Location';
        }
        if (
          basiceventData.event_location !== '' &&
          !/https?:\/\//.test(basiceventData.event_location) &&
          basiceventData.event_location.length > 500
        ) {
          error = true;
          errorMessage['event_location'] =
            'Please enter MICE Location less than 500 characters';
        }

        if (error) {
          setErrorMiceFormData(errorMessage);
          toaster('Enter all the details correctly', 'error', 'error');
          LoaderAnimation.hide();
          return;
        }
        let data = { ...miceFormData };
        Object.keys(basiceventData).map((key) => {
          data[key] = basiceventData[key];
        });
        updatedData = data;
        setMiceFormData(data);
      }

      let payload = updatedData;
      payload['type'] = 'mice';
      if (isValidDateFormat(payload['from_date']))
        payload['starts_at'] = getStartDateFormats(
          payload['from_date'],
          'start'
        );
      if (isValidDateFormat(payload['to_date']))
        payload['ends_at'] = getStartDateFormats(payload['to_date'], 'end');

      let calc = handleDaysCalculation(
        payload['from_date'],
        payload['to_date']
      );
      if (
        payload.event_break_down &&
        payload.event_break_down.length !== calc
      ) {
        if (payload.event_break_down.length > calc) {
          payload.event_break_down.splice(
            calc,
            payload.event_break_down.length - calc
          );
        }
        if (payload.event_break_down.length < calc) {
          let length = calc - payload.event_break_down.length;
          for (let i = 0; i <= length; i++) {
            const key = `Day ${payload.event_break_down.length + 1}`;
            payload.event_break_down.push({
              [key]: {
                agenda: [
                  {
                    type: '',
                    title: '',
                    start_time: '',
                    end_time: '',
                    location: '',
                    speaker_name: '',
                    speaker_designation: '',
                    speaker_topic: '',
                    speaker_details: '',
                    file_name: '',
                    description: '',
                  },
                ], menu: [{ title: '', list: [] }],
                status: '',
              },
            });
          }
        }
      }

      payload['contact_details'] = {
        coordinator_name: payload.coordinator_name,
        phone: payload.phone,
        email: payload.email,
        coordinator_name_2: payload.coordinator_name_2,
        phone_2: payload.phone_2,
        email_2: payload.email_2,
        coordinator_name_3: payload.coordinator_name_3,
        phone_3: payload.phone_3,
        email_3: payload.email_3
      };
      let agencyStructure = [];
      if (payload.self_agency_approval) {
        payload.agency = [];
      } else {
        payload.agency &&
          payload.agency.map((item) => {
            agencyStructure.push({
              id: item.value,
              name: item.label,
              status: 'null',
              emailId: item.emailId,
              quotation_path: item?.quotation_path
            });
          });
        payload.agency = agencyStructure;
      }
      let serviceStructure = [];
      payload.additional_info.service_required &&
        payload.additional_info.service_required.map((item) => {
          serviceStructure.push(item.value);
        });
      payload.additional_info.service_required = serviceStructure;
      payload.workflow_instance_id = payload['_id'];
      let instance_id = payload['_id'];
      delete payload['current_step'];
      delete payload['metadata'];
      delete payload['status'];
      delete payload['_id'];
      delete payload['quiz_title']

      let res = await putWorkflowAPI(
        payload,
        workflow['event']['_id'],
        eventsDetail.current_step,
        instance_id,
        'EDIT_EVENT'
      );
      if (res.error) {
        toaster(res.message, 'error', 'error');
        LoaderAnimation.hide();
        return;
      } else {
        toaster('MICE Updated Successfully', 'success', 'success');
        await getEventDetails();
        closeModal();
      }
    }
    LoaderAnimation.hide();
  };

  const modalFooter = (
    <HStack width={MobileWindow && '100%'}>
      {/* {selectedValue !== "edit_basic" && selectedValue !== "edit_event" && (
        <Box
          width={MobileWindow && "50%"}
          alignItems={MobileWindow && "center"}
        >
          <Text
            onPress={closeModal}
            color={COLORS.MODAL_BACK_BUTTON_COLOR}
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
            mt={3}
            mr={12}
          >
            Back
          </Text>
        </Box>
      )} */}

      {selectedValue === 'docs' && (
        <Box width={MobileWindow && '100%'}>
          <CustomButton
            onPress={async () => {
              LoaderAnimation.show();
              if (files.length === 0) {
                toaster('Please add files to upload', 'error', 'error');
                LoaderAnimation.hide();
                return;
              }

              let payload = {
                employee_file_path: [],
                documents: [],
              };
              let docs = await uploadFilesToServer(files, 'document');
              docs &&
                docs.map((item) => {
                  payload.documents.push(item);
                });

              let res = await uploadExtraEventDocs(eventsDetail._id, payload);
              if (res.error) {
                toaster(res.message, 'error', 'error');
                LoaderAnimation.hide();
                return;
              } else {
                toaster('Uploaded Successfully', 'success', 'success');
                getEventDetails();
                closeModal();
              }
              LoaderAnimation.hide();
            }}
            text='Upload'
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      )}
      {selectedValue !== 'docs' && (
        <Box width={MobileWindow && '100%'}>
          <CustomButton
            onPress={() => {
              onUpdateRequest();
            }}
            text='Update'
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      )}
    </HStack>
  );

  return (
    <>
      {!MobileWindow ? (
        <CustomModal
          isOpen={showModal}
          onClose={closeModal}
          header={getPopupModalTitle()}
          body={showModal && getPopupModalChildren()}
          footer={modalFooter}
          width={MobileWindow ? '100%' : '70%'}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={getPopupModalTitle()}
          body={showModal && getPopupModalChildren()}
          footer={modalFooter}
        />
      )}
      <Box w='100%' pl={MobileWindow ? 1 : 3}>
        <Box w='100%'>
          <HStack justifyContent={'space-between'}>
            <Text
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
              color={COLORS.ACCORDION_TITLE_COLOR}
              pb={!MobileWindow && '30px'}
              mb={MobileWindow && 4}
              pt={!MobileWindow && 4}
            >
              Basic Details
            </Text>
            {(!approved) &&
              hasPermission('EDIT_EVENT') &&
              statusMap.indexOf(eventsDetail.status) <= 3 && (
                <Box
                  mt={-2}
                  mr={!MobileWindow && 10}
                  flexDirection='row'
                  alignItems='center'
                >
                  <Pressable
                    onPress={() => {
                      openModal('edit_basic');
                    }}
                  >
                    {editIconDetailsPage}
                  </Pressable>
                </Box>
              )}
          </HStack>
          {MobileWindow ? (
            <MobileBasicDetails data={eventData} />
          ) : (
            <WebBasicDetails data={eventData} />
          )}
        </Box>
        {MobileWindow && <DividerLine direction='horizontal' />}
        <Box w='100%' pt={!MobileWindow && '2px'}>
          <HStack justifyContent={'space-between'}>
            <Text
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
              color={COLORS.ACCORDION_TITLE_COLOR}
              pb={!MobileWindow && '30px'}
              mb={MobileWindow && 4}
              pt={6}
            >
              {eventTab} Details
            </Text>
            {(!approved) &&
              hasPermission('EDIT_EVENT') &&
              statusMap.indexOf(eventsDetail.status) <= 3 && (
                <Box
                  mr={!MobileWindow && 10}
                  flexDirection='row'
                  alignItems='center'
                >
                  <Pressable
                    onPress={() => {
                      openModal('edit_event');
                    }}
                  >
                    {editIconDetailsPage}
                  </Pressable>
                </Box>
              )}
          </HStack>
          {MobileWindow ? (
            <MobileBasicDetails data={basicData} />
          ) : (
            <WebBasicDetails data={basicData} />
          )}
        </Box>
        {MobileWindow && <DividerLine direction='horizontal' />}
        <HStack justifyContent={'space-between'} mt={MobileWindow && 3}>
          {/* Vendors can view attachments; only selected vendors can upload */}
          {(hasPermission('IMAGES_REVIEWS') || hasPermission('VENDOR')) && (
              <Text
                fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                color={COLORS.ACCORDION_TITLE_COLOR}
                pb='20px'
                mt={4}
              >
                Attachments
              </Text>
            )}
          {(hasPermission('UPLOAD_DOCUMENTS') ||
            (hasPermission('VENDOR') && selected)) && (
              <Box mt={MobileWindow && 2} marginRight={!MobileWindow && '35px'}>
                <CommonAvatar
                  width={MobileWindow ? '35px' : '50px'}
                  height={MobileWindow ? '35px' : '50px'}
                  bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                  svg={addIconSVG}
                  svgwh='24'
                  view='0 0 24 24'
                  onPress={() => openModal('docs')}
                  touchable={true}
                />
              </Box>
            )}
        </HStack>
        {/* Attachments list: visible to all vendors; upload remains selected-only */}
        {(hasPermission('IMAGES_REVIEWS') || hasPermission('VENDOR')) && (
            <div
              style={{
                display: MobileWindow ? 'flex' : 'grid',
                gridTemplateColumns: `repeat(auto-fill, minmax(${80 / 3}%, 1fr))`,
                gap: '20px',
                marginRight: !MobileWindow && '20px',
                flexWrap: 'wrap',
              }}
            >
              {hasPermission('AGENCY_APPROVAL') &&
                expense &&
                Object.keys(expense).length > 0 && (
                  <AttachmentsCards
                    fileName={'Expense'}
                    fileSize={expense.file_size}
                    path={config.bucketPath + expense.file_name}
                    timeline={expense?.uploaded_time}
                    scrollToTop={scrollToTop}
                    attachments={true}
                  />
                )}
              {eventsDetail &&
                eventsDetail.documents &&
                eventsDetail.documents.length > 0 && (
                  <>
                    {eventsDetail.documents.map((item) => {
                      return (
                        <AttachmentsCards
                          fileName={item.doc_type}
                          fileSize={item.file_size}
                          path={config.bucketPath + item.file_name}
                          timeline={item?.uploaded_time}
                          scrollToTop={scrollToTop}
                          attachments={true}
                        />
                      );
                    })}
                  </>
                )}
            </div>
          )}
      </Box>
    </>
  );
};

export default BasicDetailContents;
